import { BreadcrumbList } from "@decocms/apps-commerce/types"

import { formatPrice } from "@decocms/apps-commerce/sdk/formatPrice"
import { capitalize } from "~/sdk/utils/capitalize"
import { zip } from "~/sdk/utils/zip"
import { SITE } from "~/constants"

export default function (url: string) {
    const URLi = new URL(url ?? '/', SITE.URL)

    const map = decodeURIComponent(URLi.searchParams.get('map') || '').split(',')
    const paths = URLi.pathname.split('/').filter(Boolean)

    const urlMap = zip(map, paths)

    return URLi.pathname.split('/').map((n, index) => {
        const isBrand = urlMap.find((m) => m[1].toLowerCase() === n.toLowerCase())?.[0] === 'b'

        let name = capitalize(n.replaceAll('-', ' '))
        const priceMatch = [...name.matchAll(/De (\d*\.?\d+) A (\d*\.?\d+)/gi)]

        if (isBrand) {
            name = name.toUpperCase()
        }

        if (priceMatch.length) {
            return {
                '@type': 'ListItem',
                position: index,
                name: `De ${formatPrice(Number(priceMatch[0][1]))} A ${
                    formatPrice(Number(priceMatch[0][2]))
                }`,
                item: URLi.pathname
                    .split('/')
                    .slice(0, index + 1)
                    .join('/'),
            }
        }

        return {
            '@type': 'ListItem',
            position: index,
            name,
            item: URLi.pathname
                .split('/')
                .slice(0, index + 1)
                .join('/'),
        }
    }) as BreadcrumbList['itemListElement']
}
